module.exports = __webpack_public_path__ + "static/img/nigong1.aceea33a.jpg";